<template>
  <div class="page-container-content tabgroup">
    <w-tool-tabs v-model="activeTabName">
      <el-tab-pane :label="tabs.list.label" :name="tabs.list.name">
        <w-report-list-view :active="tabs.list.active" @load-tree-data="$emit('load-tree-data')" :active-tab="activeTabName"/>
      </el-tab-pane>
      <el-tab-pane :label="tabs.hist.label" :name="tabs.hist.name">
        <w-report-hist-table :active="tabs.hist.active" @load-tree-data="$emit('load-tree-data')" :active-tab="activeTabName" />
      </el-tab-pane>
    </w-tool-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import RouterTab from '@/mixins/router/tab';
import WReportListView from './list';
import WReportHistTable from './hist';

export default {
  name: 'WReportTmplView',
  components: {
    WReportListView,
    WReportHistTable,
  },
  // mixins: [RouterTab],
  computed: mapGetters(['selectedNode']),
  data() {
    return {
      activeTabName: 'list', // TODO  라우터 확인 후 삭제
      tabs: {
        list: {
          name: 'list',
          label: '보고서 출력',
          active: false,
          default: true,
        },
        hist: {
          name: 'hist',
          label: '보고서 이력',
          active: false,
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/report/template/index.vue